// utils/areaStorage.ts
import AsyncStorage from "@react-native-async-storage/async-storage";

const STORAGE_KEY = "selected_area";
const EXPIRY_MS = 6 * 60 * 60 * 1000; // 6 hours

export const saveSelectedArea = async (areaId: string) => {
  try {
    const data = {
      areaId,
      timestamp: Date.now(),
    };
    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Failed to save area selection:", error);
  }
};

export const getSelectedArea = async (): Promise<string | null> => {
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    const age = Date.now() - data.timestamp;
    if (age > EXPIRY_MS) {
      await AsyncStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data.areaId;
  } catch (error) {
    console.error("Failed to read area selection:", error);
    return null;
  }
};

export const clearSelectedArea = async () => {
  try {
    await AsyncStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear area selection:", error);
  }
};
